var _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h25v24H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1672,
    height: 2290,
    x: -1232,
    y: -260,
    fill: "#242222",
    rx: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAE4DE",
    d: "M-200-180h560v594h-560z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#205C40",
    d: "m15.748 8.55-2.569-4.864-.675-1.286-.679 1.286L9.257 8.55l-5.415.937-1.433.248 1.013 1.043 3.832 3.94-.784 5.442-.206 1.44 1.305-.641 4.935-2.427 4.935 2.427 1.301.641-.206-1.44-.784-5.441 3.833-3.941 1.012-1.043-1.432-.248z"
  })));
};
export default SvgStarFilled;